export default {
  "slogan": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send Now Pay Later"])}
}